import './PricePod.scss';
import React from 'react';
import PricePodV2 from './V2/PricePodV2';
import FinanceProposition from '../FinanceProposition';

const PricePod = ({
	product,
	classes,
	viewModel = {},
	inStock,
	FullTitle,
	Promotions = {},
	Code,
	ColourId,
	State,
	exVat,
}) => (
	<>
		<PricePodV2
			classes={classes}
			viewModel={viewModel}
			inStock={inStock}
			FullTitle={FullTitle}
			Promotions={Promotions}
			Code={Code}
			ColourId={ColourId}
			State={State}
			exVat={exVat}
		/>

		{product && product?.State !== 'OutOfStock' && (
			<FinanceProposition {...product} />
		)}
	</>
);

export default PricePod;
